<style lang="less" scoped>

</style>
<template>
  <div class="item-selector">
    <Select
      :value="value"
      :size="size"
      :disabled="disabled"
      @on-change="setItem"
      not-found-text="请先选择公司"
      placeholder="请选择银行"
    >
      <Option
        :value="bank.id"
        v-for="bank in banks"
        :key="bank.id"
        v-if="canShowItem(bank)"
      >
        {{`${bank.account}-${bank.bank}-${bank.bank_number}${bank.del ? ' (已弃用)' : ''}`}}
      </Option>
    </Select>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      value: {
        type: Number
      },
      size: {
        type: String
      },
      width: {
        type: [Number, String],
        default: 400
      },
      disabled: {
        type: Boolean,
        default: false
      },
      company_id: {
        type: [Number, String],
        // required: true
      },
      can_cross_company: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        params: {
          search: ''
        },
        items: [],
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        banks: 'async/banks',
        banks_hash: 'async/banks_hash',
      }),
    },
    created(){
      //
    },
    mounted(){
      //
    },
    methods: {
      canShowItem(item) {
        return this.can_cross_company || (this.company_id && this.company_id === item.company_id);
      },
      setItem(id){
        const bank = this.banks_hash[id];
        this.$emit('input', id);
        this.$emit('on-change', bank);
        document.body.click();
      }
    }
  }
</script>
